import type { LucideIcon } from 'lucide-react';

export function OrgStatTile({
  icon: Icon, iconBg, iconColor, value, label,
}: { icon: LucideIcon; iconBg: string; iconColor: string; value: React.ReactNode; label: string }) {
  return (
    <div className="flex flex-1 items-start gap-4 px-6 py-5">
      <span className="flex h-[42px] w-[42px] flex-shrink-0 items-center justify-center rounded-[14px]" style={{ backgroundColor: iconBg }}>
        <Icon className="h-5 w-5" style={{ color: iconColor }} />
      </span>
      <div>
        <p className="text-[30px] font-bold leading-9 text-[#111827]">{value}</p>
        <p className="pt-0.5 text-sm font-medium text-[#6b7280]">{label}</p>
      </div>
    </div>
  );
}
